import { render, staticRenderFns } from "./setCounselor.vue?vue&type=template&id=d9f89eaa&scoped=true&"
import script from "./setCounselor.vue?vue&type=script&lang=js&"
export * from "./setCounselor.vue?vue&type=script&lang=js&"
import style0 from "./setCounselor.vue?vue&type=style&index=0&id=d9f89eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f89eaa",
  null
  
)

export default component.exports